const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	PanelBody,
	SelectControl,
	ToggleControl,
	Disabled
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/ouvertures", {
	title: __("Ouvertures", "wp-apidae"), // Block title.
	description: __("Affiche les périodes d'ouverture.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.clock
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		show_title: {
			type: "boolean",
			default: true,
		},
		field_tag: {
			type: 'string',
			default: 'h2',
		},
		align: {
			type: 'string',
			default: '',
		},
	},

	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;
			const fieldsTags          = window.WpApidaeTemplateData.fieldsTags;

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("Options")}>
						<ToggleControl
								label={ __( 'Afficher un titre de section' ) }
								checked={ attributes.show_title }
								onChange={ () => {
									props.setAttributes({ show_title: ! attributes.show_title });
								} }
							/>
							{ true === attributes.show_title &&
							<SelectControl
							label={ __( 'Balise à utiliser' ) }
							value={ attributes.field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									field_tag: newValue,
								});
							}}
						/>}
						</PanelBody>
					</InspectorControls>
				,
						<Disabled>
						<ServerSideRender
							block="wp-apidae/ouvertures"
							attributes={attributes}
							urlQueryArgs={{
							settings:template
						}}/>
					</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
